export const COMPONENT_NAME = "admin-balance-card";
